import VoiceWave from './VoiceWave';

/**
 * Full-screen loader used across app routes — replaces the spinning-ring loader
 * with a procedural voice-wave animation matching the brand aesthetic.
 */
export default function WaveLoader({ label = '' }) {
  return (
    <div
      className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center gap-5"
      data-testid="wave-loader"
    >
      <VoiceWave size="md" />
      {label && (
        <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 animate-pulse">
          {label}
        </p>
      )}
    </div>
  );
}
